import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";

const Loading = (props) => {
  const navigate = useNavigate();
  let location = useLocation();

  useEffect(() => {
    const initCheck = async () => {
      if (localStorage.getItem('tokenOperatore')) {
        navigate('/operatore/' + localStorage.getItem('tokenOperatore'));
      }
      else {
        if (localStorage.getItem("praticaTotem")) {
          localStorage.removeItem('praticaTotem');
          navigate('/homepage', { state: { isTotem: true } })
        }
        else {
          navigate('/homepage');
        }
      }
    };
    initCheck();
  }, []);
  return (
    <div className="azl-loading-container">
      <LoadingOutlined style={{ fontSize: "64px", color: "#023AAE" }} />
    </div>
  );
};

export default Loading;
